import React from 'react';
import AuthorSearch, { AuthorsProps } from './AuthorSearch';
import { Card, CardContent, Button, Grid } from '@material-ui/core';
import { useAuthentication, Role } from '../../contexts/Authentication';

export function sortAuthors(authors : { slug: string }[] = [], slugOrder: string[] = []) {
	const sort : any[] = [];
	slugOrder.forEach((slug) => {
		const author = authors.find((val) => val.slug === slug);
		if (author) sort.push(author);
	});
	authors.forEach((author) => {
		if (!sort.some((val) => val.slug === author.slug))
			sort.push(author);
	});
	return sort;
}

const Authors = (props: AuthorsProps) => {
	const auth = useAuthentication();
	const canCreateAuthor = () => {
		return auth.role.some(e => [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior].includes(e))
	};

	return <Grid item xs={12}>
		<Card>
			<CardContent>
				<Grid container justify="space-between">
					<Grid item>
						<h4>Auteurs:</h4>
					</Grid>
					<Grid item>
						{ canCreateAuthor() && <Button color="primary" variant="contained" href="/authors/create" target="_blank" rel="noopener noreferrer">Nouveau</Button> }
					</Grid>
				</Grid>
				<AuthorSearch {...props}/>
			</CardContent>
		</Card>
	</Grid>
}

export default Authors